import { render, staticRenderFns } from "./TaskDetailIFrame.vue?vue&type=template&id=5db274a5&"
import script from "./TaskDetailIFrame.vue?vue&type=script&lang=js&"
export * from "./TaskDetailIFrame.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailIFrame.vue?vue&type=style&index=0&id=5db274a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports